import useNavigationTargetRedirect from '../hooks/navigationTarget/useNavigationTargetRedirect';

const NavigationTargetRedirector = () => {
    useNavigationTargetRedirect();
};

export default NavigationTargetRedirector;
